import forge from 'node-forge';

import { createElement } from '@/shared/utils/dom/scripts';

export const printDocument = async (fileUrl: string) => {
  const resp = await fetch(fileUrl);
  const blob = await resp.blob();
  const url = files.blobToUrl(blob); //Cors avoidance

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = url;
  document.body.appendChild(iframe);
  iframe.onload = () => {
    setTimeout(() => {
      // Fix safari first render
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    }, 125);
  };
};

export const printHtml = (html: string, styles?: string) => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow?.document;
  if (doc) {
    doc.open();
    doc.write(`
      <html>
        <head>
          <style>
            ${styles ?? ''}
          </style>
        </head>
        <body>
          ${html}
        </body>
      </html>
    `);
    doc.close();

    setTimeout(() => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }, 125);
  }
};

export const sha256FromBlob = async (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const result = event.target?.result;

      if (!(result instanceof ArrayBuffer)) {
        reject();
        return;
      }

      const bytes = new Uint8Array(result);
      let binary = '';
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }

      const md = forge.md.sha256.create();
      md.update(binary);
      const hash = md.digest().toHex();

      resolve(hash);
    };

    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
};

const triggerDownload = (href: string, name: string, newTab = false) => {
  const link = createElement('a');
  link.href = href;
  link.download = name;
  link.target = newTab ? '_blank' : '_self';
  link.click();
  link.remove();
};

export const files = {
  blobToUrl: (blob: Blob) => {
    return URL.createObjectURL(blob);
  },

  downloadFile: (blob: Blob, name: string) => {
    const url = files.blobToUrl(blob);
    triggerDownload(url, name);
  },

  downloadFileByUrl: async (url: string, name: string) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch file');
      const blob = await response.blob();
      files.downloadFile(blob, name);
    } catch (err) {
      console.error('Download failed:', err);
    }
  },

  getExtension: (name: string) => {
    return name.split('.').pop()?.toLowerCase();
  },

  toBase64: (file: File) =>
    new Promise<string | null>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
          return;
        }
        resolve(null);
      };
      reader.onerror = reject;
    }),

  hasExtension: (name: string) => {
    return /\.[^./\\\s]+$/.test(name);
  },
};
